import gql from "graphql-tag";

export const expenseFragment = gql`
  fragment ExpenseFragment on Expense {
    id
    name
    date
    costNet
    costGross
    quantity
    projectId
    invoiceId
    alreadyInvoiced
  }
`;
